<template>
  <v-card flat style="max-width: 100%" class="px-4">
    <v-card-title class="py-0 pt-2 pb-2">
      <span style="font-size: 12px" class="primary--text"
        >Account Overview for <b>{{ selectedYear }}</b></span
      >
      <v-spacer></v-spacer>
      <v-btn small icon flat @click="previousYear">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <div>{{ selectedYear }}</div>
      <v-btn small icon flat @click="nextYear">
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="pt-0">
      <v-data-table hide-actions :items="[1]">
        <template slot="headers">
          <tr style="height: 36px">
            <th class="text-xs-left">Turnover</th>
            <th class="text-xs-left">Total supplier invoices</th>
            <th class="text-xs-left">Total non-contract supplier invoices</th>
            <th class="text-xs-left">Contracts net profit</th>
            <th class="text-xs-left">Total net profit</th>
            <th class="text-xs-left">Total provisional profit</th>
            <th class="text-xs-left">Total expeditions volume</th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <template v-if="!loadingTable">
            <td>
              {{ inCurrencyFromId(currencyId, accountingNumbers.turnover) }}
            </td>
            <td>
              {{
                inCurrencyFromId(
                  currencyId,
                  accountingNumbers.total_supplier_invoices
                )
              }}
            </td>
            <td>
              {{
                inCurrencyFromId(
                  currencyId,
                  accountingNumbers.total_non_contract_supplier_invoices
                )
              }}
            </td>
            <td>
              {{
                inCurrencyFromId(
                  currencyId,
                  accountingNumbers.contracts_net_profit
                )
              }}
            </td>
            <td>
              <h3>
                <b>
                  {{
                    inCurrencyFromId(
                      currencyId,
                      accountingNumbers.total_net_profit
                    )
                  }}</b
                >
              </h3>
            </td>
            <td>
              {{
                inCurrencyFromId(
                  currencyId,
                  accountingNumbers.total_provisional_profit
                )
              }}
            </td>
            <td>{{ accountingNumbers.total_expeditions_volume_mt }} mt</td>
          </template>
          <template v-else>
            <td><span class="skeleton-loader"></span></td>
            <td><span class="skeleton-loader"></span></td>
            <td><span class="skeleton-loader"></span></td>
            <td><span class="skeleton-loader"></span></td>
            <td><span class="skeleton-loader"></span></td>
            <td><span class="skeleton-loader"></span></td>
            <td><span class="skeleton-loader"></span></td
          ></template>
        </template>
      </v-data-table>
    </v-card-text>

    <v-layout row wrap px-2>
      <v-flex
        class="d-flex"
        style=""
        xs12
        sm6
        lg3
        v-for="mostProfitableX in mostProfitableLists"
        :key="mostProfitableX.name"
      >
        <v-card
          class="ma-2"
          style="
            width: -webkit-fill-available;
            max-width: -webkit-fill-available;
          "
        >
          <v-toolbar dense flat color="#eee">{{
            mostProfitableX.name
          }}</v-toolbar>

          <v-layout
            row
            wrap
            class="text-xs-center"
            v-if="!loadingTable && mostProfitableX.data.length == 0"
          >
            <v-flex class="pa-4">
              <v-label>
                <v-icon size="13" color="info">info</v-icon>

                <b> No data available for the selected year</b>
              </v-label>
            </v-flex>
          </v-layout>

          <v-list v-if="!loadingTable" dense avatar class="py-0 profitableX">
            <v-list-tile
              @click=""
              v-for="(item, index) in mostProfitableX.data"
              :key="'__' + index"
            >
              <v-list-tile-action>
                <v-icon :color="indexColor(index)">{{
                  indexInferior(index, 3)
                    ? "mdi-trophy"
                    : "mdi-numeric-" + (index + 1)
                }}</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title class="font-weight-bold caption">{{
                  item[0]
                }}</v-list-tile-title>
                <v-list-tile-sub-title class="font-weight-bold caption">{{
                  inCurrencyFromId(currencyId, item[1])
                }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn icon small @click="search(item[0])">
                  <v-icon color="grey">mdi-magnify</v-icon></v-btn
                >
              </v-list-tile-action>
            </v-list-tile>
          </v-list>

          <v-list v-else class="py-0 profitableX">
            <v-list-tile @click="" v-for="(n, index) in 5" :key="'__' + index">
              <v-list-tile-action>
                <span
                  class="skeleton-loader"
                  style="width: 26px; height: 26px"
                ></span>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title class="font-weight-bold caption"
                  ><span class="skeleton-loader" style="width: 80%"></span
                ></v-list-tile-title>
                <v-list-tile-sub-title class="font-weight-bold caption"
                  ><span
                    class="skeleton-loader"
                    style="height: 8px; width: 40%"
                  ></span
                ></v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action
                ><span class="skeleton-loader" style="width: 15px"></span>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row wrap px-2>
      <v-flex
        class="d-flex"
        style=""
        xs12
        sm6
        lg3
        v-for="mostProfitableX in mostProfitableListsByWeight"
        :key="mostProfitableX.name"
      >
        <v-card
          class="ma-2"
          style="
            width: -webkit-fill-available;
            max-width: -webkit-fill-available;
          "
        >
          <v-toolbar dense flat color="#eee">{{
            mostProfitableX.name
          }}</v-toolbar>

          <v-layout
            row
            wrap
            class="text-xs-center"
            v-if="!loadingTable && mostProfitableX.data.length == 0"
          >
            <v-flex class="pa-4">
              <v-label>
                <v-icon size="13" color="info">info</v-icon>

                <b> No data available for the selected year</b>
              </v-label>
            </v-flex>
          </v-layout>

          <v-list v-if="!loadingTable" dense avatar class="py-0 profitableX">
            <v-list-tile
              @click=""
              v-for="(item, index) in mostProfitableX.data"
              :key="'__' + index"
            >
              <v-list-tile-action>
                <v-icon :color="indexColor(index)">{{
                  indexInferior(index, 3)
                    ? "mdi-trophy"
                    : "mdi-numeric-" + (index + 1)
                }}</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title class="font-weight-bold caption">{{
                  item[0]
                }}</v-list-tile-title>
                <v-list-tile-sub-title class="font-weight-bold caption">{{
                  item[1]
                }} mt</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn icon small @click="search(item[0])">
                  <v-icon color="grey">mdi-magnify</v-icon></v-btn
                >
              </v-list-tile-action>
            </v-list-tile>
          </v-list>

          <v-list v-else class="py-0 profitableX">
            <v-list-tile @click="" v-for="(n, index) in 5" :key="'__' + index">
              <v-list-tile-action>
                <span
                  class="skeleton-loader"
                  style="width: 26px; height: 26px"
                ></span>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title class="font-weight-bold caption"
                  ><span class="skeleton-loader" style="width: 80%"></span
                ></v-list-tile-title>
                <v-list-tile-sub-title class="font-weight-bold caption"
                  ><span
                    class="skeleton-loader"
                    style="height: 8px; width: 40%"
                  ></span
                ></v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action
                ><span class="skeleton-loader" style="width: 15px"></span>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>


    <!-- <div class="pa-4 text-xs-center" v-else>
        <looping-rhombuses-spinner
          style="margin: auto;"
          class="text-xs-center"
          :animation-duration="1000"
          :size="74"
          color="#1976d2"
        />
        <h3 class="title font-weight-light my-2">Loading Data...</h3>
        <span class="caption grey--text">Please wait</span>
      </div> -->
  </v-card>
</template>

<script>
import currency from "../../../mixins/currency.js";
import ACCOUNTING_NUMBERS from "../../../graphql/accounting/dashboard.gql";
import { mapGetters } from "vuex";
import { LoopingRhombusesSpinner } from "epic-spinners";
export default {
  name: "accountingNumbers",
  mixins: [currency],
  components: {
    LoopingRhombusesSpinner,
  },
  props: {
    currencyId: {
      type: String,
      required: false,
    },
    subsidiaryId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      accountingNumbers: {},
      loadingTable: true,
      selectedYear: new Date().getFullYear(),
      bestCustomers: [],
      bestSuppliers: [],
      bestOrigins: [],
      bestDestinations: [],
      bestCustomersByWeight: [],
      bestSuppliersByWeight: [],
      bestOriginsByWeight: [],
      bestDestinationsByWeight: [],
    };
  },
  computed: {
    ...mapGetters("commonStore", ["currencies"]),
  mostProfitableListsByWeight() {
      return [
        {
          name: "Highest Volume Customers",
          data: this.bestCustomersByWeight,
        },
        {
          name: "Highest Volume Suppliers",
          data: this.bestSuppliersByWeight,
        },
        {
          name: "Highest Volume Origins",
          data: this.bestOriginsByWeight,
        },
        {
          name: "Highest Volume Destinations",
          data: this.bestDestinationsByWeight,
        },
      ];
    },
    mostProfitableLists() {
      return [
        {
          name: "Most Profitable Customers",
          data: this.bestCustomers,
        },
        {
          name: "Most Profitable Suppliers",
          data: this.bestSuppliers,
        },
        {
          name: "Most Profitable Origins",
          data: this.bestOrigins,
        },
        {
          name: "Most Profitable Destinations",
          data: this.bestDestinations,
        },
      ];
    },
  },
  mounted() {
    this.fetchAccountingNumbers();
  },
  methods: {
    search(search) {
      this.$router.push({ name: "search", query: { q: search } });
    },
    indexColor(index) {
      if (index == 0) return "amber darken-1";
      if (index == 1) return "#C0C0C0";
      if (index == 2) return "#CD7F32";

      return "black";
    },
    indexInferior(value, inferior_to) {
      return value < inferior_to;
    },
    nextYear() {
      this.selectedYear += 1;
      this.fetchAccountingNumbers();
    },
    previousYear() {
      this.selectedYear -= 1;
      this.fetchAccountingNumbers();
    },
    fetchAccountingNumbers() {
      const code = this.currencyId
        ? this.currencies.find((e) => e.id == this.currencyId).code
        : "USD";
      this.loadingTable = true;
      this.sendQuery(ACCOUNTING_NUMBERS, {
        currencyId: this.currencyId,
        subsidiaryId: this.subsidiaryId,
        baseCurrencyCode: code,
        year: this.selectedYear,
      }).then((data) => {
        let parsedBestProfit = JSON.parse(data.accounting_dashboard.best_profits)
        let parsedBestByWeight = JSON.parse(data.accounting_dashboard.best_net_weight)

        this.bestCustomers = parsedBestProfit["customers"];
        this.bestSuppliers = parsedBestProfit["suppliers"];
        this.bestOrigins = parsedBestProfit["origins"];
        this.bestDestinations = parsedBestProfit["destinations"];

        this.bestCustomersByWeight = parsedBestByWeight["customers"];
        this.bestSuppliersByWeight = parsedBestByWeight["suppliers"];
        this.bestOriginsByWeight = parsedBestByWeight["origins"];
        this.bestDestinationsByWeight = parsedBestByWeight["destinations"];


        this.loadingTable = false;
        this.accountingNumbers = data.accounting_dashboard;
      });
    },
  },
};
</script>

<style scoped>
.skeleton-loader {
  width: 100%;
  height: 15px;
  display: block;
  animation-name: aniHorizontal;
  animation-duration: 3.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.4) 50%,
      rgba(255, 255, 255, 0) 80%
    ),
    #ddd;
  background-size: 50%;
  border-radius: 8px;
}

@keyframes aniHorizontal {
  0% {
    background-position: -100% 0;
  }

  100% {
    background-position: 100% 0;
  }
}
</style>

<style>
.profitableX .v-list__tile {
  height: 52px !important;
}

.profitableX .v-list__tile__action,
.v-list__tile__avatar {
  display: flex;
  justify-content: flex-start;
  min-width: 36px;
}
</style>
